import React, { useEffect, useState } from 'react';
import './style.css';
import CssBaseline from '@mui/material/CssBaseline';
import http from '../../services/http-service'
// import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getErrorResponse } from '../../utils';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TablePagination from '@mui/material/TablePagination';


function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const theme = createTheme();

export default function ProfileDisbursement() {
  // let query = Query()use;
  // console.log('searchParams.....', query.get("tokenId"))
  // const history = useHistory();
  // const [userDetails, setUserDetails] = useState({})
  // const [language, setLanguage] = useState({})
  // const [companyDetails, setCompanyDetails] = useState({})
  // const [errorDisplay, seterrorDisplay] = useState('')
  const [open, setOpen] = useState(false);

  useEffect(() => {
    console.log(JSON.parse(localStorage.getItem('loginUser')).id)
    getUserDetails()
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  // const goBack = () =>{
  //   // history.goBack()
  // }

  // const handleSubmit = () => {
  //   let postData = {
  //     "user": JSON.parse(localStorage.getItem('loginUser')).id,
  //     "language": language
  //   }
  //   handleToggle()
  //   http('employer/user_profile_details/', 'PUT', postData)
  //     .then(res => res.data)
  //     .then(res => {
  //       if (res.status) {
  //         // getUserDetails()
  //         toast.success(res.message,{
  //           toastId: "toastId1"
  //         })
  //       }
  //       else {
  //         const error = getErrorResponse(res.message)
  //         toast.error(error, { toastId: "toastId2" ,allowHtml: true })
  //       }
  //       handleClose()
  //     })
  //     .catch(error => {
  //       toast.error("Something went wrong!",{
  //         toastId: "toastId3"
  //       })
  //       handleClose()
  //     });
  // };

  const getUserDetails = () => {
    handleToggle()
    http('employer/user_profile_details/', 'GET', '', {'user_id': JSON.parse(localStorage.getItem('loginUser')).id})
      .then(res => res.data)
      .then(res => {
        if (res.status) {
          // debugger
          // history.goBack()
          // toast.success(res.message)
          // setUserDetails(res.data)
          // setLanguage(res.data.company.language)
          // setCompanyDetails(res.data.company)
        }
        else {
          const error = getErrorResponse(res.message)
          toast.error(error, { toastId:"toastId4", allowHtml: true })
        }
        handleClose()
      })
      .catch(error => {
        toast.error("Something went wrong!",{
          toastId: "toastId5"
        })
        handleClose()
      });


  };


  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [page, setPage] = React.useState(2);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className='mainAppDiv'>

      <ThemeProvider theme={theme}>
      <CssBaseline />
          <ToastContainer />

          <div className='editFormDiv'>   
            <Typography className='AdminAddEmployerHeadding editTitle'>
              Withdrawals
              {/* <CloseIcon className='closeIcon' /> */}
            </Typography>         
            <Box sx={{ width: '100%' }}>            
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Statements" {...a11yProps(0)} />
                  <Tab label="Disbursements" {...a11yProps(1)} />
                </Tabs>
              </Box>

              <TabPanel value={value} index={0}>
                  Statements
              </TabPanel>

              <TabPanel value={value} index={1}>                                  
                  <Box sx={{ flexGrow: 1 }} className="profileDisburDiv">
                    <Typography className='AdminAddEmployerHeadding editTitle'>
                      Withdrawals                    
                    </Typography>   
                    <Grid container pb={2} mb={2} className="border-bottom">
                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='acceptedLink'><a href onClick={(e)=> e.preventDefault() }>Accepeted</a></Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className='widthDrawalDate'>
                      You received: <span>&#x20A6;</span> 1249.20 + <span>&#x20A6;</span> 0.80 fee                    
                      </Typography>  
                      </Grid>
                    </Grid>

                    <Grid container pb={2} mb={2} className="border-bottom">
                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='acceptedLink'><a href onClick={(e)=> e.preventDefault() }>Accepeted</a></Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className=''>
                      You received: <span>&#x20A6;</span> 1249.20 + <span>&#x20A6;</span> 0.80 fee
                      </Typography>  
                      </Grid>
                    </Grid>

                    <Grid container pb={2} mb={2}>
                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='acceptedLink'><a href onClick={(e)=> e.preventDefault() }>Accepeted</a></Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className=''>
                      You received: <span>&#x20A6;</span> 1249.20 + <span>&#x20A6;</span> 0.80 fee                   
                      </Typography>  
                      </Grid>
                    </Grid>
                  </Box>

                  <Box sx={{ flexGrow: 1 }} className="profileDisburDiv">
                    <Typography className='AdminAddEmployerHeadding editTitle'>
                      Pending transactions                    
                    </Typography>   
                    <Grid container pb={2} mb={2} className="border-bottom">
                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Pending</Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className=''>
                         You received: <span>&#x20A6;</span> 1249.20 + <span>&#x20A6;</span> 0.80 fee                    
                      </Typography>  
                      </Grid>
                    </Grid>

                    <Grid container pb={2} mb={2} className="border-bottom">
                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Pending</Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className=''>
                         You received: <span>&#x20A6;</span> 1249.20 + <span>&#x20A6;</span> 0.80 fee                    
                      </Typography>  
                      </Grid>
                    </Grid>

                    <Grid container pb={2} mb={2}>
                      <Grid item xs={6}>
                      <Typography className=''>Monday 10 May 21</Typography>
                      </Grid>

                      <Grid item xs={6}>
                      <Typography className='widthDrawalDate'>Pending</Typography>
                      </Grid>
                      <Grid item xs={12}>
                      <Typography className=''>
                         You received: <span>₦</span> 1249.20 + <span>₦</span> 0.80 fee                    
                      </Typography>  
                      </Grid>
                    </Grid>
                  </Box>

                  <TablePagination
                    component="div"
                    count={100}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />

              </TabPanel>
              
            </Box>
          </div>

          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
            <CircularProgress color="inherit" />
          </Backdrop>

      </ThemeProvider>
    </div>

  );
}